interface CDTCode {
  id: number;
  code: string;
  description: string;
  coverage_percentage?: number;
  coverage_summary?: string;
}

interface CDTCodesTableProps {
  data: CDTCode[];
}

export function CDTCodesTable({ data }: CDTCodesTableProps) {
  if (!data || data.length === 0) {
    return (
      <div className='rounded-xl border p-8 text-center' style={{ borderColor: '#E5E7EB', backgroundColor: '#F9FAFB' }}>
        <p className='text-sm text-gray-500'>No CDT codes available</p>
      </div>
    );
  }

  return (
    <div className='overflow-x-auto rounded-xl border' style={{ borderColor: '#E5E7EB' }}>
      <table className='w-full'>
        <thead style={{ backgroundColor: 'var(--clinic-primary)', opacity: 0.05 }}>
          <tr>
            <th className='px-6 py-4 text-left text-xs font-semibold uppercase tracking-wider' style={{ color: 'var(--clinic-text)' }}>
              CDT Code
            </th>
            <th className='px-6 py-4 text-left text-xs font-semibold uppercase tracking-wider' style={{ color: 'var(--clinic-text)' }}>
              Description
            </th>
            <th className='px-6 py-4 text-left text-xs font-semibold uppercase tracking-wider' style={{ color: 'var(--clinic-text)' }}>
              Coverage
            </th>
          </tr>
        </thead>
        <tbody className='divide-y divide-gray-200'>
          {data.map((row) => (
            <tr
              key={row.id}
              className='transition-colors duration-200 hover:bg-gray-50'
            >
              <td className='px-6 py-4 text-sm font-semibold' style={{ color: 'var(--clinic-primary)' }}>
                {row.code}
              </td>
              <td className='px-6 py-4 text-sm' style={{ color: 'var(--clinic-text)' }}>
                {row.description}
              </td>
              <td className='px-6 py-4 text-sm font-medium' style={{ color: 'var(--clinic-text)' }}>
                {row.coverage_percentage
                  ? `${row.coverage_percentage}%`
                  : row.coverage_summary || 'N/A'}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

